<template>
    <div
        class="fixed flex justify-center text-white bottom-5 right-5 left-5 md:bottom-auto md:left-auto md:top-5 md:max-w-sm"
        :class="{ 'hidden': !show }"
        style="z-index: 1000"
    >
        <div class="text-sm text-center bg-gray-900 text-white shadow-md px-8 py-4 rounded">
            <p class="mb-1 font-bold">
                Save this app to your
                <span class="md:hidden">phone!</span>
                <span class="hidden md:inline">device!</span>
            </p>
            <p class="mb-1">Play Rat T whenever you want.</p>

            <p class="flex justify-center mt-4 mb-4">
                <button
                    class="rounded-lg px-6 py-2 bg-white text-gray-900 text-gray-200 hover:bg-gray-200 active:bg-gray-100"
                    @click.prevent.stop="promptGoogleInstall"
                >Install Now</button>
            </p>
            <p>
                <a
                    class="text-gray-200 text-xs"
                    @click.prevent.stop="hideCustomPrompt"
                    href="#"
                >Dismiss</a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        };
    },
    created() {
        this.deferredPrompt = null;

        window.addEventListener('beforeinstallprompt', e => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
            // Update UI notify the user they can install the PWA
            this.showCustomPrompt();
        });
    },
    methods: {
        promptGoogleInstall() {
            this.hideCustomPrompt();

            // Show the install prompt
            this.deferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            this.deferredPrompt.userChoice.then(choiceResult => {
                if (typeof ga !== 'undefined') {
                    ga('send', 'event', 'app_to_home', choiceResult.outcome);
                }
            });
        },
        showCustomPrompt() {
            this.show = true;

            gsap.from(this.$el, {
                opacity: 0,
                y: '-=10',
                duration: 0.7,
            });
        },
        hideCustomPrompt() {
            gsap.to(this.$el, {
                opacity: 0,
                y: '-=10',
                duration: 0.25,
                onComplete: () => {
                    this.show = false;
                },
            });
        },
    },
};
</script>

<style>
</style>